import { useMemo, useCallback } from 'react';
import {
	selectCompanies,
	selectAuthenticationContext,
} from '../selectors/authenticationContext.selectors';
import { getCompanies } from '../actions/authenticationContext.actions';
import { useDispatch, useSelector } from 'react-redux';
import { AUTHENTICATION_PROVIDER, AuthType } from '../types';

export const useCompanies = () => {
	const dispatch = useDispatch();
	const {
		isFetching,
		isInitialized,
		list: companies,
	} = useSelector(selectCompanies);
	const { defaultSite } = useSelector(selectAuthenticationContext);

	// TODO Figure out a better way to determine login type
	const isForge =
		localStorage.getItem(AUTHENTICATION_PROVIDER) == AuthType.Forge;

	const initializeCompanies = useCallback(() => {
		// Companies are not used on Forge
		if (isForge) return;
		// Ignore initialization attempts while fetching
		if (isInitialized || isFetching) return;
		dispatch(getCompanies({ initializing: true }));
	}, [isForge, isInitialized, isFetching]);

	const activeCompany = useMemo(
		() => companies?.find(company => company.organization === defaultSite),
		[companies],
	);

	const alternateCompanies = useMemo(
		() =>
			companies?.filter(company => company.organization !== defaultSite),
		[companies],
	);
	return {
		activeCompany,
		alternateCompanies,
		initializeCompanies,
		companies,
	};
};
